import axios from 'axios';
import Notyf from 'notyf';

import errorsMessages from './errors-messages';

export const notyf = new Notyf({ delay: 5000 });
const instance = axios.create();

instance.interceptors.response.use(
  response => response,
  (error) => {
    const { data, status } = error.response;

    if (data.code && errorsMessages[+data.code]) {
      notyf.alert(errorsMessages[+data.code]);
    }

    if (status === 502) {
      notyf.alert(errorsMessages.DEFAULT);
    }

    return Promise.reject(error);
  },
);

export default instance;
